
import { hygraphSrcset } from "@/utils/hygraphImage";
import { PAIR_SIZES, PAIR_WIDTHS } from "@/components/blog/imageSlots";

export default {
  name: "ImagePair",
  props: {
    block: { type: Object, required: true },
  },
  data() {
    return { PAIR_SIZES };
  },
  computed: {
    leftSrcset() {
      return hygraphSrcset(this.block.leftImage, PAIR_WIDTHS);
    },
    rightSrcset() {
      return hygraphSrcset(this.block.rightImage, PAIR_WIDTHS);
    },
  },
};
